import { Component, Vue, Prop } from 'vue-property-decorator';
import ArrowSmall from '@/assets/icons/arrow-small.svg?inline';

@Component({
  components: {
    ArrowSmall,
  },
})
export default class AccordionItem extends Vue {
  @Prop(String)
  readonly title!: string;

  isActive: boolean = false;

  get isActiveItem() {
    return this.isActive;
  }

  collapse() {
    this.isActive = !this.isActive;
  }
}
